module.exports = __webpack_public_path__ + "static/media/acerta-star-icon.a9e3ed8b.svg";